const INITIAL_STATE = {
	transacoes: {
		hoje: {
			dados: { data: [] },
			loading: false,
			error: null,
		},
		ontem: {
			dados: { data: [] },
			loading: false,
			error: null,
		},
		dias30: {
			dados: { data: [] },
			loading: false,
			error: null,
		},
		error: false,
	},
	bandeiras: { lista: [], loading: false, error: null },
	modalidade: { lista: [], loading: false, error: null },
	topDias: {
		lista: [],
		loading: false,
		error: null,
	},
	recebimentos: {
		lista: [],
		loading: false,
		error: null,
	},
	graficoEvolutivo: {
		lista: [],
		loading: false,
		error: null,
	},
};

// eslint-disable-next-line default-param-last
export function clientDashboard(state = INITIAL_STATE, action) {
	switch (action.type) {
		case '@clientDash/REQUEST_TRANSACOES':
			return {
				...state,
				transacoes: {
					...state.transacoes,
					hoje: { ...state.transacoes.hoje, loading: true },
					error: false,
				},
			};

		case '@clientDash/SUCCESS_TRANSACOES':
			return {
				...state,
				transacoes: {
					...state.transacoes,
					hoje: {
						dados: action.payload.dados,
						loading: false,
						error: null,
					},
					error: false,
				},
			};

		case '@clientDash/FAILURE_TRANSACOES':
			return {
				...state,
				transacoes: {
					...state.transacoes,
					hoje: {
						dados: {},
						loading: false,
						error: action.payload.error,
					},
					error: true,
				},
			};

		case '@clientDash/REQUEST_TRANSACOES_ONTEM':
			return {
				...state,
				transacoes: {
					...state.transacoes,
					ontem: { ...state.transacoes.hoje, loading: true },
					error: false,
				},
			};

		case '@clientDash/SUCCESS_TRANSACOES_ONTEM':
			return {
				...state,
				transacoes: {
					...state.transacoes,
					ontem: {
						dados: action.payload.dados,
						loading: false,
						error: null,
					},
					error: false,
				},
			};

		case '@clientDash/FAILURE_TRANSACOES_ONTEM':
			return {
				...state,
				transacoes: {
					...state.transacoes,
					ontem: {
						dados: {},
						loading: false,
						error: action.payload.error,
					},
					error: true,
				},
			};

		case '@clientDash/REQUEST_TRANSACOES_30_DIAS':
			return {
				...state,
				transacoes: {
					...state.transacoes,
					dias30: { ...state.transacoes.hoje, loading: true },
					error: false,
				},
			};

		case '@clientDash/SUCCESS_TRANSACOES_30_DIAS':
			return {
				...state,
				transacoes: {
					...state.transacoes,
					dias30: {
						dados: action.payload.dados,
						loading: false,
						error: null,
					},
					error: false,
				},
			};

		case '@clientDash/FAILURE_TRANSACOES_30_DIAS':
			return {
				...state,
				transacoes: {
					...state.transacoes,
					dias30: {
						dados: {},
						loading: false,
						error: action.payload.error,
					},
					error: true,
				},
			};

		case '@clientDash/REQUEST_BANDEIRAS':
			return {
				...state,
				bandeiras: { ...state.bandeiras, loading: true },
			};

		case '@clientDash/SUCCESS_BANDEIRAS':
			return {
				...state,

				bandeiras: {
					lista: action.payload.lista,
					loading: false,
					error: null,
				},
			};

		case '@clientDash/FAILURE_BANDEIRAS':
			return {
				...state,
				bandeiras: {
					lista: [],
					loading: false,
					error: action.payload.error,
				},
			};

		case '@clientDash/REQUEST_TOP_DIAS_VENDAS':
			return {
				...state,
				topDias: { ...state.topDias, loading: true },
			};

		case '@clientDash/SUCCESS_TOP_DIAS_VENDAS':
			return {
				...state,
				topDias: {
					lista: action.payload.lista,
					loading: false,
					error: null,
				},
			};

		case '@clientDash/FAILURE_TOP_DIAS_VENDAS':
			return {
				...state,
				topDias: {
					lista: [],
					loading: false,
					error: action.payload.error,
				},
			};

		case '@clientDash/REQUEST_MODALIDADE':
			return {
				...state,
				modalidade: { ...state.modalidade, loading: true },
			};

		case '@clientDash/SUCCESS_MODALIDADE':
			return {
				...state,
				modalidade: {
					lista: action.payload.lista,
					loading: false,
					error: null,
				},
			};

		case '@clientDash/FAILURE_MODALIDADE':
			return {
				...state,
				modalidade: {
					lista: [],
					loading: false,
					error: action.payload.error,
				},
			};

		case '@clientDash/REQUEST_RECEBIMENTOS':
			return {
				...state,
				recebimentos: { ...state.recebimentos, loading: true },
			};

		case '@clientDash/SUCCESS_RECEBIMENTOS':
			return {
				...state,
				recebimentos: {
					lista: action.payload.lista,
					loading: false,
					error: null,
				},
			};

		case '@clientDash/FAILURE_RECEBIMENTOS':
			return {
				...state,
				recebimentos: {
					lista: [],
					loading: false,
					error: action.payload.error,
				},
			};

		case '@clientDash/REQUEST_GRAFICO_EVOLUTIVO':
			return {
				...state,
				graficoEvolutivo: {
					...state.graficoEvolutivo,
					loading: true,
				},
			};

		case '@clientDash/SUCCESS_GRAFICO_EVOLUTIVO':
			return {
				...state,
				graficoEvolutivo: {
					lista: action.payload.lista,
					loading: false,
					error: null,
				},
			};

		case '@clientDash/FAILURE_GRAFICO_EVOLUTIVO':
			return {
				...state,
				graficoEvolutivo: {
					lista: [],
					loading: false,
					error: action.payload.error,
				},
			};
		default:
			return state;
	}
}
